import { Feature } from "common/types";

import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useFeatures } from "client/clinics/hooks";

import { DetailSubscription, EligibleRetentionOffer, ListSubscription } from "../../types";
import {
  getRetentionOfferDeadlineFinePrint,
  getRetentionOfferDeliveryDisplay,
  getRetentionOfferDiscountDisplay,
} from "../../utils";

export type SubscriptionRetentionOfferAcceptedStepProps = {
  subscription: DetailSubscription | ListSubscription;
  offer: EligibleRetentionOffer;
  onDone: () => void;
};

/** Confirms an accepted offer, since the autoship the client came to cancel is left untouched. */
const SubscriptionRetentionOfferAcceptedStep = ({
  subscription,
  offer,
  onDone,
}: SubscriptionRetentionOfferAcceptedStepProps) => {
  const isEdbEnabled = useFeatures()[Feature.AutoshipEDB];
  const discount = getRetentionOfferDiscountDisplay(offer);
  const description = [
    `Your discount comes off ${getRetentionOfferDeliveryDisplay(subscription, { isEdbEnabled })}.`,
    getRetentionOfferDeadlineFinePrint(offer, { isEdbEnabled }),
    "Your autoship stays on its current schedule, so there is nothing else to do.",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ConfirmationDialog
      title={`${discount} off is applied`}
      description={description}
      confirmText="Done"
      onConfirm={onDone}
      onDeny={onDone}
      hasDenyButton={false}
    />
  );
};

export default SubscriptionRetentionOfferAcceptedStep;
